import getters from './getters'
import mutations from './mutations'
import actions from './actions'
const state = {
  activeStepForm: localStorage.getItem('formStep') || '',
  allLinks: [],
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
